import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d79bf1c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Registration" }
const _hoisted_2 = { class: "RegistrationBody" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SocialIncentiveButtons = _resolveComponent("SocialIncentiveButtons")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_DirectSigninButton = _resolveComponent("DirectSigninButton")!
  const _component_PrivacyStatement = _resolveComponent("PrivacyStatement")!
  const _component_RedirectToLogin = _resolveComponent("RedirectToLogin")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _renderSlot(_ctx.$slots, "header", {}, undefined, true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SocialIncentiveButtons, { template: "Big" }),
      _createVNode(_component_Divider),
      _createVNode(_component_DirectSigninButton),
      _createVNode(_component_PrivacyStatement),
      _createVNode(_component_RedirectToLogin)
    ])
  ]))
}